/**
 * Tête de Mule – custom cart drawer.
 *
 * 1) Keeps the free shipping bar's fill width + message text, and the
 *    "Standard Shipping" label in the summary box, in sync with the cart
 *    total on every AJAX cart change (the theme's own CartShippingMessage
 *    class only knows how to animate a circular ring, so the linear bar
 *    needs its own tiny script).
 * 2) Opens the cart drawer automatically after a product is added from a
 *    product page, instead of the theme's small "added to cart" popdown.
 */
(function () {
  'use strict';

  function formatMoney(cents, format) {
    if (typeof cents !== 'number') {
      cents = Number(cents) || 0;
    }
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var formatted = (format || '{{amount}}').replace(/\{\{\s*amount\s*\}\}/, parts[0] + ',' + parts[1]);
    formatted = formatted.replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0]);
    formatted = formatted.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, parts[0] + ',' + parts[1]);
    formatted = formatted.replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, parts[0]);
    return formatted;
  }

  function broadcastCart(cart) {
    document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart: cart } }));
    document.dispatchEvent(new CustomEvent('theme:cart:reload'));
  }

  /* ---------------------------------------------------------------- */
  /* 1) Free shipping bar + summary label                             */
  /* ---------------------------------------------------------------- */

  function updateShippingBars(cart) {
    var bars = document.querySelectorAll('[data-tdm-shipping-bar]');
    bars.forEach(function (bar) {
      var limit = parseFloat(bar.getAttribute('data-limit'));
      if (!limit) {
        return;
      }
      var limitCents = limit * 100;
      var total = cart.total_price || 0;
      var percent = Math.min((total / limitCents) * 100, 100);
      var reached = total >= limitCents;

      var fill = bar.querySelector('[data-tdm-shipping-fill]');
      if (fill) {
        fill.style.width = percent + '%';
      }

      bar.classList.toggle('is-success', reached);

      var textEl = bar.querySelector('[data-tdm-shipping-text]');
      if (textEl) {
        if (reached) {
          textEl.textContent = bar.getAttribute('data-success-text') || '';
        } else if (window.theme && window.theme.moneyFormat) {
          var remainingCents = Math.max(limitCents - total, 0);
          var remaining = formatMoney(remainingCents, window.theme.moneyFormat).replace(',00', '');
          var template = bar.getAttribute('data-progress-template') || '';
          textEl.textContent = template.replace('||amount||', remaining);
        }
      }
    });
  }

  // The "Standard Shipping: Free / Calculated at checkout" label only gets
  // fresh data when the summary box's own AJAX partial reloads, which can
  // lag a beat behind the shipping bar above it (which updates live on
  // every cart change). Patch it directly here too so the two can never
  // show contradictory states even for a moment.
  function updateShippingLabel(cart) {
    var label = document.querySelector('[data-tdm-shipping-label]');
    if (!label) {
      return;
    }
    var limit = parseFloat(label.getAttribute('data-limit'));
    if (!limit) {
      return;
    }
    var reached = (cart.total_price || 0) >= limit * 100;
    label.textContent = reached
      ? label.getAttribute('data-free-text')
      : label.getAttribute('data-checkout-text');
    label.classList.toggle('tdm-cart__summary__free', reached);
  }

  // Same staleness problem as the shipping label above: the theme's own
  // updateTotal() only runs as part of a full loadForm() cycle, so the
  // footer total can end up showing a leftover value from an earlier cart
  // state. Keep it in sync with every cart change directly too.
  function updateTotal(cart) {
    var totalEl = document.querySelector('[data-cart-final]');
    if (!totalEl || !window.theme || !window.theme.moneyFormat) {
      return;
    }
    var price = formatMoney(cart.total_price || 0, window.theme.moneyFormat);
    totalEl.textContent = price + (window.theme.currencyCode ? ' ' + window.theme.currencyCode : '');
  }

  document.addEventListener('theme:cart:change', function (event) {
    if (event.detail && event.detail.cart) {
      updateShippingBars(event.detail.cart);
      updateShippingLabel(event.detail.cart);
      updateTotal(event.detail.cart);
    }
  });

  /* ---------------------------------------------------------------- */
  /* 2) Auto-open the drawer after "add to cart" from a product page  */
  /* ---------------------------------------------------------------- */

  // assets/theme.js's productForm only opens the small "added to cart"
  // popdown when the drawer isn't already open (theme:cart:popdown, bubbles
  // true). We can't reliably cancel that native listener (it's registered
  // before this script runs), so instead we hide the popdown UI with CSS
  // and open the drawer ourselves on the same event.
  document.addEventListener('theme:cart:popdown', function () {
    var drawer = document.getElementById('drawer-cart');
    if (!drawer) {
      return;
    }
    drawer.dispatchEvent(new CustomEvent('theme:drawer:open', { bubbles: false }));

    // The theme's own CartItems only re-fetches the cart on open if it has
    // no cached copy yet (this.cart is still null) - otherwise it reuses
    // whatever it fetched the *last* time the drawer opened, which doesn't
    // include the item that was just added. Force a fresh fetch ourselves
    // so the drawer always shows the item straight away instead of only
    // after closing and reopening it.
    window
      .fetch(window.theme.routes.cart + '.js')
      .then(function (response) {
        return response.json();
      })
      .then(broadcastCart)
      .catch(function (e) {
        console.error(e);
      });
  });
})();
